import { Controller } from "stimulus";
import { quickSearchTemplateHref } from "../helpers/quick_search_template_url";

export default class extends Controller {

  changeTemplate(evt) {
    const selectedOption = evt.target.options[evt.target.selectedIndex];
    if (selectedOption) {
        const newParamValue = $(selectedOption).val();
        window.location.href = quickSearchTemplateHref(
          window.location.pathname,
          newParamValue,
          window.location.search
        );
    }
  }
}